import { render, staticRenderFns } from "./ServiceProject.vue?vue&type=template&id=b7903e28&"
import script from "./ServiceProject.vue?vue&type=script&lang=js&"
export * from "./ServiceProject.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProject.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports